/**
 * tdesign v0.46.2
 * (c) 2022 tdesign
 * @license MIT
 */

'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var linear = function linear(current, start, end, duration) {
  var change = end - start;
  var offset = change * current / duration;
  return offset + start;
};
var easeInOutCubic = function easeInOutCubic(current, start, end, duration) {
  var change = (end - start) / 2;
  var time = current / (duration / 2);

  if (time < 1) {
    return change * time * time * time + start;
  }

  time -= 2;
  return change * (time * time * time + 2) + start;
};

exports.easeInOutCubic = easeInOutCubic;
exports.linear = linear;
//# sourceMappingURL=easing.js.map
